import { Grid } from "@material-ui/core";
import { FakeContent, TextLabel } from "../../shared/components";
import FechamentoConsumoGrafico from "./fechamentoConsumoGrafico";
import React from "react";
import { CustomTooltip } from "components/CustomTooltip";
import { t } from "adapters/i18n";

export const getConsumoFormatado = (
  gramaCabecaDia,
  valorPrimario,
  valorSecundario,
  eDecimal = true,
) => {
  const valor = gramaCabecaDia ? valorPrimario : valorSecundario;
  return eDecimal
    ? Number(valor || 0).toFixed(1)
    : Math.floor(Number(valor || 0));
};

export const ConsumoInfo = ({
  dadosCarregados,
  faixaAceite,
  ConsumoOcorrido,
  ConsumoObjetivo,
  index,
  tooltipStyle,
  valorConsumo,
  consumoFormula,
  inlineStyleConsumoOcorrido,
  gramaCabecaDia,
  ConsumoObjetivo100KgPv,
  ConsumoOcorrido100KgPv,
}) => {
  return (
    <Grid container direction="column" justify="space-between">
      <CustomTooltip
        className={tooltipStyle}
        title={t("supplementation:actual-consumption-info")}
        arrow
      >
        <Grid item data-testid="ConsumoOcorrido">
          <FakeContent showContent={dadosCarregados} height={16} width="50%">
            <TextLabel
              color="default2"
              bold
              size={15}
              id={`labelConsumoOcorrido-${index}`}
            >
              {gramaCabecaDia
                ? t("supplementation:actual-consumption-head")
                : t("supplementation:actual-consumption-lw")}
              :{" "}
            </TextLabel>
            <TextLabel
              data-testid="valorConsumoOcorrido"
              id={`valorConsumoOcorrido-${index}`}
              size={14}
              bold
              className={valorConsumo}
              customStyle={inlineStyleConsumoOcorrido}
            >
              {getConsumoFormatado(
                gramaCabecaDia,
                ConsumoOcorrido,
                ConsumoOcorrido100KgPv,
              )}
            </TextLabel>
          </FakeContent>
        </Grid>
      </CustomTooltip>

      <CustomTooltip
        className={tooltipStyle}
        title={t("supplementation:target-consumption-info")}
      >
        <Grid item data-testid="ConsumoObjetivo">
          <FakeContent showContent={dadosCarregados} height={16} width="70%">
            <TextLabel
              id={`labelConsumoObjetivo-${index}`}
              color="default2"
              size={14}
            >
              {gramaCabecaDia
                ? t("supplementation:target-consumption-head")
                : t("supplementation:target-consumption-lw")}
              :{" "}
            </TextLabel>
            <TextLabel
              data-testid="valorConsumoObjetivo"
              id={`valorConsumoObjetivo-${index}`}
              size={14}
              color="default2"
              bold
              className={valorConsumo}
            >
              {getConsumoFormatado(
                gramaCabecaDia,
                ConsumoObjetivo,
                ConsumoObjetivo100KgPv,
                false,
              )}
            </TextLabel>
          </FakeContent>
        </Grid>
      </CustomTooltip>

      <FakeContent
        showContent={dadosCarregados}
        height={110}
        id={`fechamentoConsumoGrafico-${index}`}
      >
        <FechamentoConsumoGrafico
          data-testid="fechamentoConsumoGrafico"
          faixaAceite={faixaAceite}
          consumoFormula={consumoFormula}
        />
      </FakeContent>
    </Grid>
  );
};
